import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { TOKEN_KEY, errMsg } from "@/pos/lib/api";

const staffApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
staffApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default function PosMenuDialog({ categories, onClose, onSaved }) {
  const [f, setF] = useState({ name: "", price: "", category: categories[0] || "", options: [], show_in_app: false });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const setOpt = (i, k, v) => set("options", f.options.map((o, j) => (j === i ? { ...o, [k]: v } : o)));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await staffApi.post("/staff/menu", {
        name: f.name.trim(), price: Number(f.price), category: f.category.trim(), show_in_app: f.show_in_app, available: true,
        options: f.options.filter((o) => o.name.trim()).map((o) => ({ name: o.name.trim(), price_delta: Number(o.price_delta) || 0 })),
      });
      toast.success(`${f.name} ditambah`);
      onSaved();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto" data-testid="pos-menu-dialog">
        <DialogHeader><DialogTitle className="font-heading">Tambah Menu POS</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3 text-sm">
          <Input required value={f.name} onChange={(e) => set("name", e.target.value)} placeholder="Nama menu" data-testid="pos-menu-name" />
          <div className="grid grid-cols-2 gap-2">
            <Input required type="number" step="0.01" min="0" value={f.price} onChange={(e) => set("price", e.target.value)} placeholder="Harga (RM)" data-testid="pos-menu-price" />
            <Input required list="pos-menu-cats" value={f.category} onChange={(e) => set("category", e.target.value)} placeholder="Kategori" data-testid="pos-menu-category" />
            <datalist id="pos-menu-cats">{categories.map((c) => <option key={c} value={c} />)}</datalist>
          </div>
          <div>
            <div className="mb-2 flex items-center justify-between"><b>JIKA NAK TAMBAH</b>
              <button type="button" onClick={() => set("options", [...f.options, { name: "", price_delta: 0 }])} data-testid="pos-menu-add-option" className="flex items-center gap-1 text-xs font-semibold text-red-700"><Plus size={12} />Tambah</button>
            </div>
            {f.options.map((o, i) => (
              <div key={i} className="mb-2 flex gap-2">
                <Input value={o.name} onChange={(e) => setOpt(i, "name", e.target.value)} placeholder="Nama tambahan" data-testid={`pos-menu-option-name-${i}`} />
                <Input type="number" step="0.01" value={o.price_delta} onChange={(e) => setOpt(i, "price_delta", e.target.value)} placeholder="+RM" className="w-24" data-testid={`pos-menu-option-price-${i}`} />
                <button type="button" onClick={() => set("options", f.options.filter((_, j) => j !== i))} className="p-2 text-rose-600"><X size={16} /></button>
              </div>
            ))}
          </div>
          <label className="flex items-center justify-between gap-3">
            <span>Papar juga dalam app pelanggan<span className="block text-xs text-slate-500">Biar mati jika menu ini untuk POS sahaja</span></span>
            <Switch checked={f.show_in_app} onCheckedChange={(v) => set("show_in_app", v)} data-testid="pos-menu-show-in-app" />
          </label>
          <button type="submit" disabled={busy} data-testid="pos-menu-save" className="btn-primary h-11 w-full disabled:opacity-60">{busy ? "Menyimpan..." : "Simpan Menu"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
